<template>
  <div
    v-if="intercomForced && isCareHealthBannerDisplayed"
    data-test="care-health-banner"
  >
    <RevBanner :label="bannerMessage" @close="closeCareHealthBanner" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBanner } from '@ds/components/Banner'

import { useCareHealthBannerStore } from '../../stores/useCareHealthBannerStore'

import translations from './CareHealthBanner.translations'
import { useCarePlatformHealth } from './composables/useCarePlatformHealth/useCarePlatformHealth'

export type CareHealthBannerContext = 'seller' | 'agent' | 'customer'

const props = withDefaults(
  defineProps<{
    /** Who the banner is shown to; picks the message wording. */
    context?: CareHealthBannerContext
  }>(),
  { context: 'customer' },
)

const i18n = useI18n()

const { isCareHealthBannerDisplayed } = storeToRefs(useCareHealthBannerStore())
const { closeCareHealthBanner } = useCareHealthBannerStore()

// Show the banner only when the CloudBees ops.forceIntercomBanner flag is on.
// Fetch errors stay hidden (fail-closed) so the banner can never get stuck on.
const { intercomForced } = useCarePlatformHealth()

const bannerMessage = computed(() => {
  if (props.context === 'agent') {
    return i18n(translations.intercomForcedAgent)
  }

  if (props.context === 'seller') {
    return i18n(translations.intercomForcedSeller)
  }

  return i18n(translations.intercomForcedCustomer)
})
</script>
